import { initTabs } from '../common'
/**
 * AdvancedSearch page
 */
class AdvancedSearch{
    constructor(settings) {
        this.texts = settings.texts;
        this.initLayout();
    }

    initLayout() {
        var that = this;

        initTabs();

        $('button[type="submit"]', 'div.advanced-search').click(function() {
            var element = $(this);
            var form = element.closest('form');

            $.ajax({
                url: form.attr('action'),
                dataType: 'json',
                method: 'post',
                data: form.serialize(),

                success: function(data) {
                    $('section.results').html(data.results);
                }
            });
        });

        $('input[name="tags"]').tokenInput("/common/token-tags/", {
            hintText: that.texts.searchTags,
            placeholder: that.texts.tags,
            preventDuplicates: true,
            minChars: 2,
            tokenLimit: 10
        });
        /*
        $('input[name="location"]').tokenInput("/common/token-location/", {
            hintText: that.texts.searchLocation,
            placeholder: that.texts.location,
            preventDuplicates: true,
            minChars: 2,
            tokenLimit: 10
        });
        */
        $('input[name="hosts"]').tokenInput("/common/token-hosts", {
            hintText: that.texts.searchHosts,
            placeholder: that.texts.hosts,
            preventDuplicates: true,
            minChars: 2,
            tokenLimit: 20
        });

        $('input[name="categories"]').tokenInput("/common/token-categories/", {
            hintText: that.texts.searchCategories,
            placeholder: that.texts.categories,
            preventDuplicates: true,
            minChars: 2,
            tokenLimit: 20
        });

        $('input[name="start-date"]').datepicker({
            weekStart: 1,
            format: "d.m.yyyy"
        });

        $('input[name="end-date"]').datepicker({
            weekStart: 1,
            format: "d.m.yyyy"
        });

        if ($('#combined input[name="name"]').val().length > 0)
            $("#submit_combined").click();

        this.initLocation($('#location-combined').get(0), 'combined');
        this.initLocation($('#location-events').get(0), 'events');
        this.initLocation($('#location-hosts').get(0), 'hosts');
        this.initLocation($('#location-users').get(0), 'users');
    }

    initLocation(input, parent) {
        var autocomplete = new google.maps.places.Autocomplete(input, { types: ['(cities)'] }); //, { types: ['(cities)'] } , { types: ['establishment'] }

        google.maps.event.addDomListener(input, 'blur', function(e) {
            // clear data if empty
            if($(this).val().length == 0){
                $('#' + parent + '-city-name').val('');
                $('#' + parent + '-country-code').val('');
                $('#' + parent + '-sublocality').val('');
                $('#' + parent + '-lat').val('');
                $('#' + parent + '-lng').val('');
            }

        });

        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            var place = autocomplete.getPlace();

            if(place.geometry === undefined) return false;

            $('#' + parent + '-lat').val(place.geometry.location.lat());
            $('#' + parent + '-lng').val(place.geometry.location.lng());

            var sublocality = '';
            var city = '';
            var country = '';

            $.each(place.address_components, function(key, value) {
                if ($.inArray("sublocality", value.types) >= 0) {
                    sublocality = value.long_name;
                    $('#' + parent + '-sublocality').val(sublocality);
                }
                else if ($.inArray("locality", value.types) >= 0) {
                    city = value.long_name;
                    $('#' + parent + '-city-name').val(city);
                }
                else if ($.inArray("country", value.types) >= 0) {
                    country = value.short_name;
                    $('#' + parent + '-country-code').val(country);
                }
            });
            if (sublocality == '')
                $('#' + parent + '-sublocality').val(sublocality);
            if (city == '')
                $('#' + parent + '-city-name').val(city);
            if (country == '')
                $('#' + parent + '-country-code').val(country);
        });
    }
}

export { AdvancedSearch }
